module.exports = __webpack_public_path__ + "static/img/3245_phase_function_Paper_Points.faf1742.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3245_phase_function_Paper_Points.png
// module id = wb44
// module chunks = 0